'use strict';

import {fabric} from 'fabric-webpack';
export default fabric.Color;



/** WEBPACK FOOTER **
 ** ./src/Color.js
 **/